export { default as FontsProvider, typekitLoadingStrategies } from './Fonts.provider'
